import { render, staticRenderFns } from "./AlterationHistory.vue?vue&type=template&id=4a05935e&scoped=true"
import script from "./AlterationHistory.vue?vue&type=script&lang=js"
export * from "./AlterationHistory.vue?vue&type=script&lang=js"
import style0 from "./AlterationHistory.vue?vue&type=style&index=0&id=4a05935e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a05935e",
  null
  
)

export default component.exports